export function scrollAppToTop() {
  window.scrollTo(0, 0)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0

  const root = document.getElementById('root')
  const main = document.querySelector('main')

  if (root) root.scrollTop = 0
  if (main) main.scrollTop = 0

  if (document.activeElement && typeof document.activeElement.blur === 'function') {
    document.activeElement.blur()
  }
}

export function scheduleScrollAppToTop() {
  scrollAppToTop()

  const timers = [
    window.requestAnimationFrame(() => scrollAppToTop()),
    window.setTimeout(() => scrollAppToTop(), 60),
    window.setTimeout(() => scrollAppToTop(), 180),
  ]

  return () => {
    window.cancelAnimationFrame(timers[0])
    window.clearTimeout(timers[1])
    window.clearTimeout(timers[2])
  }
}
